import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-finance-payment-record",
  "use": "icon-finance-payment-record-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-finance-payment-record\">\r\n  <defs><style type=\"text/css\"></style></defs>\r\n  <path d=\"M512 64C264.8 64 64 264.8 64 512s200.8 448 448 448 448-200.8 448-448S759.2 64 512 64z m0 832c-211.2 0-384-172.8-384-384s172.8-384 384-384 384 172.8 384 384-172.8 384-384 384z\" p-id=\"2118\" />\r\n  <path d=\"M320 320h384v64H320zM320 416h384v64H320zM320 512h384v64H320zM320 608h384v64H320z\" p-id=\"2119\" />\r\n  <path d=\"M320 256h64v64h-64zM416 256h64v64h-64zM512 256h64v64h-64zM608 256h64v64h-64z\" p-id=\"2120\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/finance-payment-record.svg
// module id = rVpV
// module chunks = 49